import Ajax from '@/lib/ajax'
export default {
  /**
   * 创建充值活动
   * @param data
   */
  add(data: any) {
    return Ajax.post(`/api/MarketingManagement/RechargeActivity`, data)
  },
  /**
   * 更新充值活动
   * @param id 
   * @param data 
   */
  update(id: string, data: any) {
    return Ajax.put(`/api/MarketingManagement/RechargeActivity/${id}`, data)
  },
  /**
   * 删除充值活动
   * @param id 
   */
  delete(id: string) {
    return Ajax.delete(`/api/MarketingManagement/RechargeActivity/${id}`)
  },
  /**
   * 获取充值活动
   * @param id 
   */
  get(id: string) {
    return Ajax.get(`/api/MarketingManagement/RechargeActivity/${id}`)
  },
  /**
   * 获取充值活动列表
   * @param MaxResultCount 
   * @param currentPage 
   * @param KeyWord 
   */
  getList(MaxResultCount: number, currentPage: number, KeyWord?: string) {
    return Ajax.get(`/api/MarketingManagement/PromotionActivity`, {
      params: {
        MaxResultCount,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
        KeyWord,
      },
    })
  },
}
